import { addStyles } from 'ethcss'
import { colors, IStyles, mediaCSS } from 'theme'

const categoryAdd: IStyles = {
    categoryAdd: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 2000,
    },
    inner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 20,
        filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
        backgroundColor: colors.white,
        width: 960,
        height: 'calc(100% - 40px)',
        padding: 34,

        [mediaCSS.tab]: {
            width: '96%',
            padding: 16,

            [mediaCSS.tabMini]: {
                height: 'auto',
            },
        },
    },
    field: {
        marginBottom: 20,
    },
    controls: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 60,

        [mediaCSS.tabMini]: {
            marginTop: 24,
        },
    },
    button: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 148,
        height: 34,

        [mediaCSS.tabMini]: {
            width: 130,
        },
    },
    selectLogo: {
        width: '100%',
    },
    itemStyles: {
        width: '100% !important',
    },
    tr: {
        border: `1px solid ${colors.grey}`,
        td: {
            verticalAlign: 'middle',
            padding: 10,
        },
        'td:first-child': {
            width: 'calc(100% - 40px)',
        },
        'td:last-child': {
            width: '40px',
        },
    },
    trHeader: {
        backgroundColor: colors.greyLight,
    },
    tableWrapper: {
        height: 'calc(100% - 300px)',
        overflow: 'auto',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        boxSizing: 'border-box',
    },
    addGroupDesc: {
        margin: '14px 0',
    },
    channelSelectBtn: {
        marginTop: 24,
        marginBottom: 24,
    },
    controlsWide: {
        display: 'flex',
        justifyContent: 'space-between',
        width: 320,
        marginTop: 60,
        margin: '0 auto',

        [mediaCSS.tabMini]: {
            marginTop: 24,
            width: 280,
        },
    },
    channelSelectionBlock: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 'calc(100% - 96px)',
    },
    selectionCol: {
        width: '47%',
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
        border: `1px solid ${colors.grey}`,
        borderRadius: 5,
    },
    trSelection: {
        td: {
            verticalAlign: 'middle',
            padding: 10,
            boxSizing: 'border-box',
        },
        'td:first-child': {
            width: 20,
        },
    },
    disabled: {
        opacity: 0.5,
        cursor: 'not-allowed',
    },
}

addStyles(categoryAdd)
export default categoryAdd
